import { configureStore } from './configure-store';

export const { persistor, store, browserHistory } = configureStore();
